/** Prevents production Webpack from emitting empty chunks for stub-only entries. */
export function registerBundle(name) {
  if (typeof window === "undefined") return;
  window.__themeWebpackBundles = window.__themeWebpackBundles || [];
  window.__themeWebpackBundles.push(name);
}
